<template>
  <div class="control color-control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div
            v-if="hintStatus"
            class="control__trigger"
            @mouseover="showHint = true"
            @mouseleave="showHint = false"
          >
            <img src="https://sirv.sirv.com/website/theme2/icon/question.svg" :alt="hint" />
          </div>
          <div v-show="showHint" class="hint">
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          class="fakeoverlay"
          :class="{ disabled: !selectStatus }"
          @click="selectStatus = !selectStatus"
        />
        <el-color-picker
          v-if="rgba === false"
          v-model="value"
          class="colorpicker"
          :disabled="!selectStatus"
          @change="changeOptionCSS"
        />
        <el-color-picker
          v-else
          v-model="value"
          class="colorpicker"
          show-alpha
          :disabled="!selectStatus"
          @change="changeOptionCSS"
        />
      </div>
      <el-checkbox v-model="selectStatus" class="control__checkbox" @change="changeOptionCSS" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "ColorPickerCSS",
  props: {
    title: {
      type: String,
      default: "",
    },
    default: {
      type: String,
      default: "",
    },
    rgba: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    hint: {
      type: String,
      default: "",
    },
    hintStatus: {
      type: Boolean,
      default: true,
    },
    parameter: {
      type: String,
      default: "",
    },
    status: {
      type: Boolean,
    },
    eventClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: this.default,
      selectStatus: this.status,
      showHint: false,
    };
  },
  computed: {
    ...mapState(["clearOptionsCSS", "clearOptions", "settings"]),
    storeOptions() {
      return (
        this.settings.optionsCSS.length &&
        !!this.settings.optionsCSS.find((e) => e.parameter === this.parameter)
      );
    },
  },
  watch: {
    clearOptionsCSS(val) {
      if (val) {
        this.value = this.default;
        this.selectStatus = false;
      }
    },
    eventClick(val) {
      if (val) {
        this.selectStatus = val;
        this.value = this.default;
      }
    },
    selectStatus(val) {
      if (val) {
        this.changeOptionCSS();
      }
    },
    storeOptions(val) {
      if (!val && this.selectStatus) {
        this.selectStatus = false;
      }
    },
  },
  methods: {
    changeOptionCSS() {
      const value = this.selectStatus === true ? `${this.value}` : "";
      this.$emit("changeOptionCSS", {
        type: this.type,
        parameter: `${this.parameter}`,
        separator: ":",
        value: value,
      });
    },
  },
};
</script>
